<template>
  <svg width="40" height="40" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10 0.5C15.5228 0.5 20 4.97715 20 10.5C20 16.0228 15.5228 20.5 10 20.5C4.47715 20.5 0 16.0228 0 10.5C0 4.97715 4.47715 0.5 10 0.5ZM13.2197 7.46967L8.75 11.9393L6.78033 9.96967C6.48744 9.67678 6.01256 9.67678 5.71967 9.96967C5.42678 10.2626 5.42678 10.7374 5.71967 11.0303L8.21967 13.5303C8.51256 13.8232 8.98744 13.8232 9.28033 13.5303L14.2803 8.53033C14.5732 8.23744 14.5732 7.76256 14.2803 7.46967C13.9874 7.17678 13.5126 7.17678 13.2197 7.46967Z"
      :fill="color"
    />
  </svg>
</template>

<script setup>
// #region - prop definitions
const props = defineProps({
  color: {
    type: String,
    required: false,
    default: '#32A84B'
  }
})
// endregion
</script>
